export default __webpack_public_path__ + "static/media/new-logo-dubbing-vi.c6f9e3e4.svg";